module.exports = fox._r("intercom/images/ico-chat-sprite_valentine.png", __webpack_public_path__ + "_/_/_/_/_/common-components/intercom/images/ico-chat-sprite_valentine.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/intercom/images/ico-chat-sprite_valentine.png
// module id = 59
// module chunks = 5